/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'bill (eur)': {
    width: 16,
    height: 16,
    viewBox: '0 0 40.45 61',
    data: '<defs/><g id="Layer_2" data-name="Layer 2"><g id="Layer_1-2" data-name="Layer 1"><path pid="0" class="cls-1" d="M40.17 60.36L36 58.25a.65.65 0 0 0-.58 0l-4.86 2.43-4.86-2.43a.67.67 0 0 0-.29-.07.65.65 0 0 0-.29.07l-4.86 2.43-4.86-2.43a.65.65 0 0 0-.58 0l-4.89 2.43-4.86-2.43a.65.65 0 0 0-.58 0L.28 60.36V.28h39.89z"/><path pid="1" class="cls-1" d="M31.46 11.45a9.55 9.55 0 0 0-7.52-4c-5.76 0-10.44 5.83-10.44 13s4.67 13 10.44 13a9.51 9.51 0 0 0 7.41-3.85M8.99 16.39h14.2M8.99 24.1h14.2M6.69 40.28h27.08M6.69 48.27h27.08"/></g></g>'
  }
})



// WEBPACK FOOTER //
// ./src/icons/bill (eur).js